const initialState = {
    data: [],
  };
  
  const wspolnotyReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_WSPOLNOTY':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default wspolnotyReducer;